export const aboutData = {
  title: "Who I am",
  description1:
    "My name's Kalil. I'm a web designer and developer based in France, FR.",
  description2:
    "During the day I work as a Front Web Developer remotely and in the evening I work on freelance projects and use my time to create my own products.",
  image: 1,
};
